queryMatches = (first, second) ->
  first.toLowerCase().indexOf( second.toLowerCase().trim() ) != -1

App.ModifierGroupEditController = Em.Controller.extend
  session: Em.inject.service()
  notifier: Em.inject.service()

  env:     Em.inject.service('environment')

  isStepperMode: Em.computed.equal('modifierGroup.view_type', 'stepper')
  isSelectMode: Em.computed.equal('modifierGroup.view_type', 'select')


  needs: [ 'modifier-groups' ]
  modifierGroupBinding: 'model'
  currencyUnit: Em.computed.alias('session.currency.unit')
  enabledCustomRestaurantPrice: Em.computed.alias('modifierGroup.organization.features.dish_restaurant_prices')

  updatePrices: (->
    return unless @get('enabledCustomRestaurantPrice')
    @get('modifierGroup.modifiers').forEach (modifier) ->
      modifier.checkRestaurantsInPrices()
  ).observes('modifierGroup.id')

  actions:
    setRestaurantPrice: (modifier, restaurant_price) ->
      restaurant_price.set('price', @get('dish.price') || '0')

    setCustomRestaurantPrice: (modifier)->
      modifier.set('settingCustomRestaurantPrice', true)

    setCustomRestaurantPriceOff: (modifier)->
      modifier.get('restaurant_prices').map((a) -> a).forEach (rp) ->
        if rp.get('id')
          rp.set('modifier', null)
        else
          rp.destroyRecord()

      modifier.set('settingCustomRestaurantPrice', false)

    cancel: ->
      modifierGroup = @get('modifierGroup')

      if modifierGroup.get('isDirty') or modifierGroup.get('isNew')
        # todo i18n
        return unless confirm 'Отменить изменения?'
        modifierGroup = @get('modifierGroup')
        modifierGroup.rollback()

      @send('goBackToModifierGroupList')

      false

    addModifierGroupItem: () ->
      @get('modifierGroup.modifiers').pushObject @get('store').createRecord 'modifier',
        modifier_name: Em.I18n.t 'modifier_group.edit.modifiers.new_modifier'
        modifier_price: 0
        external_id: null

    deleteModifierGroupItem: (modifier) ->
      @get('modifierGroup.modifiers').removeObject(modifier) if confirm('Удалить модификатор?')


    deleteModifierGroup: ->
      # todo i18n
      return unless confirm 'Удалить группу?'

      modifierGroup = @get('modifierGroup')
      modifierGroup.destroyRecord()
      .then =>
        @transitionToRoute('modifierGroups')

      false

    saveModifierGroup: ->
      modifierGroup = @get('modifierGroup')

      wasNew = modifierGroup.get('isNew')

      @set('isLoading', true)
      modifierGroup.save()
      .catch =>
        @get('notifier').pushNotification
          type: 'error'
          # todo i18n
          title: 'Ошибка сохранения'
          message: 'Группа модификаторов не сохранена, проверьте введенные данные.'
          duration: 30000
      .then (data) =>
        @get('notifier').pushNotification
          type: 'success'
          # todo i18n
          title: 'Группа сохранена'
          duration: 3000

        modifierGroup.get('modifiers').forEach (modifier) ->
          modifierGroup.reload()
          .then =>
            modifierGroup.get('modifiers').removeObject(modifier) if modifier && !modifier.get('id')

        @transitionToRoute('modifier-groups') if wasNew
      .finally =>
        @set('isLoading', false)

      false

    queryDishes: (defer, query) ->
      organization = @get('organization')

      @store.find('dish', search: query)
      .then(defer.resolve, defer.reject)

      false


    openFileDialog: (id) ->
      input = Em.$("[dataId=#{id}]")
      return unless input
      input.click()
      false

    uploadPhoto: (file, id) ->
      modifierGroup = @get('modifierGroup')
      modifier = modifierGroup.get('modifiers').find (modifier) => modifier.get('id') is id
      return unless modifier

      modifier.set('fileIsUploading', true)

      modifier.uploadPhoto(file).then =>
        modifier.reload()
        .finally =>
          modifier.set('fileIsUploading', false)
      false
